import { createSelector } from 'reselect';

import { IRootState } from '../../../reducers';
import { mapScienceContestsResponse } from './mappers';

const scienceContestsSelector = createSelector(
  [
    (state: IRootState) => state.studentEvents,
    (state: IRootState) => state.studentRewards,
    (state: IRootState) => state.sectionRef,
  ],
  (studentEvents, studentRewards, sectionRef) => {
    return mapScienceContestsResponse(studentEvents, studentRewards, sectionRef);
  },
);

export default scienceContestsSelector;
